export default __webpack_public_path__ + "static/media/IMG9373.c9fb8b7f.jpg";